import React from 'react';
import { CheckIcon } from 'lucide-react';
type CheckItemProps = {
  children: React.ReactNode;
  className?: string;
};
export function CheckItem({
  children,
  className = ''
}: CheckItemProps) {
  return <li className={`flex items-start gap-2.5 ${className}`} data-id="element-19" data-mp="2746an5r9q6ej">
      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cyan-500 text-zinc-950" data-id="element-20" data-mp="271k2p50gtovs">
        <CheckIcon className="h-3 w-3" strokeWidth={3.5} aria-hidden="true" data-id="element-21" data-mp="1x4p82x7bc8ms" />
      </span>
      <span data-id="element-22" data-mp="2241u5fqd1bob">{children}</span>
    </li>;
}